exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PieChartSet {\n    display: flex;\n    flex-flow: column nowrap;\n    justify-content: stretch;\n    width: 100%;\n\n    margin-bottom: 2em;\n}\n\n    .PieChartSet__title {\n        flex-grow: 0;\n        flex-shrink: 0;\n        margin-bottom: 2em;\n    }\n\n    .PieChartSet__charts {\n        flex-grow: 1;\n        flex-shrink: 1;\n\n        display: flex;\n        flex-flow: row wrap;\n        justify-content: stretch;\n        align-items: stretch\n    }\n\n    .PieChartSet__charts>* {\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-basis: 50%;\n}", ""]);

// exports
